import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';

export type VariantType =
  | 'T1' // font-size 10px
  | 'T2' // font-size 12px
  | 'T3' // font-size 14px
  | 'T4' // font-size 16px
  | 'T5' // font-size 20px
  | 'T6' // font-size 24px
  | 'T7' // font-size 8px
  | 'T8' // font-size 32px
  | 'T9' // font-size 22px
  | 'T10' // font-size 18px
  | 'unset';

export type ColorType =
  | 'Nero'
  | 'Dark_Grey'
  | 'Light_Grey'
  | 'Dove_Grey'
  | 'Pelorous'
  | 'Bali'
  | 'White_Smoke'
  | 'White'
  | 'Bahamas'
  | 'Salmon'
  | 'Dark_salmon'
  | 'Alice_Blue'
  | 'Jade'
  | 'Charcoal'
  | 'Black'
  | 'Light_Black'
  | 'Chinese_Black'
  | 'Grey_88'
  | 'Grey_33'
  | 'Grey_98'
  | 'Light_Charcoal'
  | 'Valencia'
  | 'Mongoose'
  | 'Gold'
  | 'Font_Grey'
  | 'Dark_Blue_Grey'
  | 'Grey_A0'
  | 'Grey_White'
  | 'Chartreuse_Yellow'
  | 'Link_Water'
  | 'Atlantis'
  | 'Fleek_Yellow'
  | 'Fleek_Green'
  | 'Fleek_footer'
  | 'PelorousDark'
  | 'Cerulean'
  | 'Forest_green'
  | 'Fleek_jade'
  | 'Fleek_Light_Grey'
  | 'New_Pelorous'
  | 'Dark_Gold'
  | 'Light_Grey_2' 
  | 'Gift_with-purchase__text'
  | 'Info_blue'
  | 'GWP_Primary'
  | 'GWP_Text'
  | 'Medium_Black'
  | 'Error_red'
  | 'Red';

export type TextDecorationType = 'strikethrough' | 'underlined' | 'none';

export type WeightType = 'regular' | 'bold';
export interface TextProps {
  weight?: WeightType; // Regular or Bold
  variant?: VariantType;
  textTransform?: 'is-capitalized' | 'is-uppercase' | 'is-lowercase' | 'none';
  color?: ColorType;
  children: React.ReactChildren | string | any;
  textDecoration?: TextDecorationType;
  id?: string;
  customClass?: string;
  ariaLabel?: string;
  ariaDescribedBy?: string;
  ariaLive?: boolean | string;
  removeGrouping?:boolean;
  isSizeGuide?: boolean;
  isRadioButton?: boolean;
  ariaHidden?: boolean;
  role?: string;
  ariaLevel?: number;
  tabIndex?: number;
  customStyles:React.CSSProperties | undefined;
  hideInternalElements: boolean;
}
const cx = classNames.bind(styles);

const Text: React.FC<TextProps> = (props: TextProps) => {
  const {
    weight,
    variant,
    textTransform,
    color,
    textDecoration,
    children,
    id = '',
    customClass = '',
    ariaLabel,
    ariaDescribedBy,
    ariaLive = 'off',
    isRadioButton = false,
    isSizeGuide = false,
    ariaHidden = false,
    removeGrouping = false,
    role,
    ariaLevel,
    tabIndex,
    customStyles = {},
    hideInternalElements=false
  } = props;
  const classes = cx('Text', {
    [`${weight}`]: true,
    [`${variant}`]: true,
    [`${textTransform}`]: true,
    [`${color}`]: true,
    [`${textDecoration}`]: textDecoration !== 'none',
    [`${customClass}`]: true
  });

    return (
    <span
      className={classes}
      {...(!removeGrouping ?{ 'id': `${id}`} :{})}
      {...(ariaHidden ? { 'aria-hidden': 'true' } : {})}
      {...(ariaDescribedBy ? { 'aria-describedby': `${ariaDescribedBy}`} : {})}

      {...(ariaLabel ? {'aria-label': `${ariaLabel}`}: {})}
      style={{
        ...{ display: isRadioButton ? 'none' : '' },
        ...customStyles
      }}
      {...(!removeGrouping && ariaLive != 'off' ?{ 'aria-live': `${ariaLive}`} :{})}
      role={role}
      {...(!isSizeGuide && ariaLevel && {'aria-level': `${ariaLevel}`})}
      tabIndex={tabIndex === 0 ? 0 : (tabIndex || undefined)}
      {...(ariaLive != 'off' && !removeGrouping ? {
        "aria-atomic":'true'
      } : {})}
    >
      {weight === 'bold' ? (
        isSizeGuide ? ariaLevel ? (
          <h4 role="heading" aria-level={ariaLevel}>
            <strong>{children}</strong>
          </h4>
        ) : (
          <h4 role="heading" aria-level="1">
            <strong>{children}</strong>
          </h4>
        ) : (
          <strong aria-hidden={hideInternalElements ? true : undefined}>{children}</strong>
        )
      ) : (
        children
      )}
    </span>
  );
};

Text.defaultProps = {
  weight: 'regular',
  variant: 'T2',
  color: 'Nero',
  textTransform: 'none',
  textDecoration: 'none'
};

export default Text;
